<template>
    <div>
        <template
            v-if="!loading"
        >
            <template
                v-for="(property, index) in objects.objects"

            >
                <v-divider
                    v-if="index !== 0"
                    class="mx-4"
                ></v-divider>

                <div
                    class="d-flex align-center"
                >
                    <div
                        class="mr-2 d-flex justify-center align-center"
                        style="width: 100px; height: 100px;"
                    >
                        <v-icon
                            :color="$vuetify.theme.dark ? 'white' : 'primary'"
                            size="70"
                        >
                            {{ property.icon }}
                        </v-icon>
                    </div>

                    <div>
                        <div
                            class="d-flex align-center"
                        >
                            <p
                                class="mr-1 mb-0"
                                :class="textClass"
                            >
                                {{ getPropertyValue(property) }}
                            </p>

                            <v-tooltip
                                bottom
                                v-if="getPropertyDescription(property)"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        color="grey lighten-1"
                                        small
                                    >
                                        $mdiInformation
                                    </v-icon>
                                </template>
                                <span v-html="getPropertyDescription(property)"/>
                            </v-tooltip>
                        </div>
                        <p
                            :class="propertyLabelClass"
                        >
                            {{ property.label }}
                        </p>
                    </div>
                </div>
            </template>

            <v-divider></v-divider>

            <template
                v-for="(property, index) in objects.properties"
            >

            </template>
        </template>
    </div>
</template>

<script>
    import SummaryValue from "../../../Global/SummaryValue";
    import SummaryBreakdown from "../../../Global/SummaryBreakdown";

    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-Benefactor',

        components: {
            SummaryValue,
            SummaryBreakdown
        },

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            },
            'small': {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            objects() {
                return this.properties_objects[this.client.benefactor_type];
            },
            propertyLabelClass() {
                let css = this.$vuetify.theme.dark ? 'white--text' : 'primary--text';

                if (this.small) {
                    css += ' summary-value-mobile';
                } else {
                    css += ' summary-value-desktop';
                }

                return css;
            },
            textClass() {
                let css = this.propertyLabelClass;

                css += ' font-weight-bold';

                return css;
            },
            debug() {
                return process.env.NODE_ENV !== 'production';
            }
        },

        data() {
            return {
                loading: true,

                properties_objects: {},
            }
        },

        mounted() {
            this.setPropertyObjects();
        },

        methods: {
            setPropertyObjects() {
                this.properties_objects = {
                    1: {
                        'objects': [
                            {
                                'label': 'Free cover based on the selected ' + this.getLppLabel(this.client.lpp_type) + ' LPP™',
                                'icon': '$mdiLegacyMoreBenefitFreeCover',
                                'value': 'lppBenefactorAmount',
                            },
                            {
                                'label': 'The value of cover we can give at cost',
                                'icon': '$mdiLegacyMoreBenefitCoverValue',
                                'value': 'lifeBenefit',
                            },
                            {
                                'label': 'Estate fees saved by indemnifying the cover',
                                'icon': '$mdiLegacyMoreBenefitEstateFee',
                                'value': 'feeIndemnity',
                            }
                        ],
                        'properties': [
                            {
                                'label': 'More benefit',
                                'values': [
                                    'benefactorOption' + this.client.benefactor_type,
                                ]
                            },
                        ]
                    },
                    2: {
                        'objects': [
                            {
                                'label': 'Credit from the selected ' + this.getLppLabel(this.client.lpp_type) + ' LPP™',
                                'icon': '$mdiLegacyLessPremiumCredit',
                                'value': 'lppBenefactorAmount',
                            },
                            {
                                'label': 'The saving on expenses we can give back',
                                'icon': '$mdiLegacyLessPremiumSaving',
                                'value': 'lifeBenefitAlternate',
                            },
                            {
                                'label': 'Estate fees saved by indemnifying the cover',
                                'icon': '$mdiLegacyLessPremiumEstateFee',
                                'value': 'feeIndemnity',
                            }
                        ],
                        'properties': [
                            {
                                'label': 'Discounted cover',
                                'values': [
                                    'benefactorOption' + this.client.benefactor_type,
                                ]
                            },
                        ]
                    },
                    3: {
                        'objects': [
                            {
                                'label': 'Pay back from the selected ' + this.getLppLabel(this.client.lpp_type) + ' LPP™',
                                'icon': '$mdiLegacyCashBackPayBack',
                                'value': 'cashBackLppPortion',
                            },
                            {
                                'label': 'The saving on expenses we can pay back',
                                'icon': '$mdiLegacyCashBackSaving',
                                'value': 'cashBackLifePortion',
                            },
                            {
                                'label': 'The value of cover we can give at cost',
                                'icon': '$mdiLegacyLessPremiumCredit',
                                'value': 'staticBenefitForCashBack',
                            },
                            {
                                'label': 'Estate fees saved by indemnifying the cover',
                                'icon': '$mdiLegacyCashBackEstateFee',
                                'value': 'feeIndemnity',
                            },
                        ],
                        'properties': [
                            {
                                'label': 'Total Cash Back',
                                'values': [
                                    'benefactorOption' + this.client.benefactor_type,
                                ]
                            }
                        ]
                    }
                };

                this.loading = false;
            },
            isGreyed(property) {
                return property === 'beneFactorAmount';
            },
            isInverted(property) {
                return property === 'beneFactorTotal';
            },

            getPropertyValue(property) {
                let suffix = '';
                let value = 0;

                if (typeof this.benefits !== 'undefined' && typeof this.benefits[property.value] !== 'undefined' && typeof this.benefits[property.value].value !== 'undefined') {
                    if (this.benefits[property.value].value == 1000000000 && property.value == 'productMaximumIndemnity') {
                        value = 'Unlimited';
                    } else if (this.unlimited && (property.value === 'productMaximumIndemnity' || property.value === 'lppBenefits')) {
                        value = 'Unlimited';
                    } else if (property.value === 'productIndemnificationCoveragePercentage') {
                        value = this.benefits[property.value].value + '% Covered';
                    } else if (property.value === 'productIndemnificationShortfallPercentage') {
                        value = this.benefits[property.value].value + '% Shortfall';
                    } else {
                        value = this.currencyFilter(this.benefits[property.value]);
                    }
                }

                if (typeof this.benefits !== 'undefined' && typeof this.benefits[property.value] !== 'undefined' && typeof this.benefits[property.value].suffix !== 'undefined' && this.benefits[property.value].suffix) {
                    suffix = ' ' + this.benefits[property.value].suffix;
                }

                return value + suffix;
            },
            getPropertyDescription(property) {
                let description = '';

                if (typeof this.benefits !== 'undefined' && typeof this.benefits[property.value] !== 'undefined' && typeof this.benefits[property.value].description !== 'undefined' && this.benefits[property.value].description) {
                    if (this.debug) {
                        description += property.value + ' - ';
                    }

                    description += this.benefits[property.value].description;
                }

                return description;
            },
        }
    }
</script>
